import { Component, OnInit , ViewChild } from '@angular/core';
import { UsersService, UserModel } from 'src/app/Api_Module';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  users: UserModel[] = [];
  loadingSearch: boolean;
  selectedUser: UserModel;
  cache: UserModel[] = [];
  filtervalue;

  messages = { emptyMessage: 'No Users found.', totalMessage: 'Total Users' };
  constructor(private userService: UsersService, private toastr: ToastrService) {

  }

  loadUsers() {
    this.loadingSearch = true;
    this.userService.all().subscribe((resp: UserModel[]) => {

      this.users = resp;
      this.cache = resp;
      console.log(this.users);
      this.loadingSearch = false;
    },
      error => {
        this.loadingSearch = false;
        this.toastr.error('Users Not Found!');
        console.log('error:' + JSON.stringify(error));
      });
  }
  updateFilter(event) {
    const val = this.filtervalue;

    if (val) {
      // filter our data
      const temp = this.users.filter(function (d) {
        return (d.firstName && d.firstName.toLowerCase().indexOf(val.toLowerCase()) !== -1) ||
          (d.lastName && d.lastName.toLowerCase().indexOf(val.toLowerCase()) !== -1) ||
          (d.username && d.username.toLowerCase().indexOf(val.toLowerCase()) !== -1) ||
          !val;
      });

      // update the rows
      this.users = temp;
    } else {
      this.users = [... this.cache];
    }
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  deleteUser(id: number) {
    this.userService._delete(id).subscribe(resp => {
      this.toastr.success('Users Deleted!');
      this.loadUsers();
    },
      error => {
        this.loadingSearch = false;
        this.toastr.error('User Not Found!');
        console.log('error:' + JSON.stringify(error));
      });
  }

  clearFilter() {
    this.filtervalue = '';
    this.users = [... this.cache];
  }

  ngOnInit() {
    this.loadUsers();
  }

}
